import App from "./App";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { apiSlice } from "./redux/api/apiSlice.js";
import { ApiProvider } from "@reduxjs/toolkit/query/react";
// Bootstrap Styles
import "bootstrap/dist/css/bootstrap.min.css";
// Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "swiper/css/autoplay";
// My Styles
import "./App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
   <ApiProvider api={apiSlice}>
      <BrowserRouter>
         <App />
      </BrowserRouter>
   </ApiProvider>
);
